import React, { Component,Fragment } from 'react';
import { connect } from 'react-redux';
import { apiReportHistories } from '../../store/actions/companyActions';
import 'rc-datetime-picker/dist/picker.css';
import { Table, Button } from 'reactstrap';
import Spinner from '../../components/Spinner';
import { utcDateFormat } from '../../store/actions/UtilsOperation';
class ModalReportsHistories extends Component {
	constructor(props){
		super(props);
		this.state = {
            reportsQuerys: [],
            newReportsList: this.props.reportsList.map(item=> item.reports).flat(),
            loading: true,
            reportHistories: {}
        }
	}

	componentDidMount() {
		const { session } = this.props;
		this.props.apiReportHistories(session.account_id);
	}

    componentDidUpdate(prevProps) {
        if(prevProps.reportHistories !== this.props.reportHistories){
            this.handleNewReportHistories();
        }
    }

    handleNewReportHistories = () => {
        const { newReportsList } = this.state;

        const querys = [];
        newReportsList.forEach(report => {
            const query = this.props.handleReportsQuery({}, report.value);
            const splitedQuery = query.split("/");
            const newQuery = splitedQuery[splitedQuery.length - 1];
            querys.push({
                query: newQuery,
                name: report.name
            })
        });
        
        let newReportHistories = (this.props.reportHistories && this.props.reportHistories.data) || null;

        if(newReportHistories){
            newReportHistories = newReportHistories.filter(report => querys.some(query => report.name === query.query));
        }

        this.setState({
            loading: false,
            reportsQuerys: querys,
            reportHistories: {
                data: newReportHistories
            }
        })
    }

    handleReload = () => {
        this.setState({
            loading: true
        })
		this.props.apiReportHistories(this.props.session.account_id).then(() => {
			this.setState({
				loading: false
			})
		})
	}

	render() {
        const { loading, reportsQuerys, reportHistories } = this.state;
        const { companyColor, json_lang } = this.props;

        if(loading){
			return	<div className="d-flex justify-content-center" style={{ margin: "20%" }}>
                <Spinner size='100px' color={companyColor} />
            </div>
        }

        if(reportHistories && reportHistories.data){

            const reportStatusStyle = {
                in_queue: "secondary",
                generating: "warning",
                failed: "danger"
            } 

            return <div style={{ overflowY: "auto", maxHeight: "450px" }}>
                <Table style={{ border: '1px solid #c8ced3' }}>
                    <thead>
                        <tr>
					    	<th><b>Reporte</b></th>
					    	<th><b>Fecha de solicitud</b></th>
					    	<th><b>Rango de fechas</b></th>
					    	<th><b>Acción</b></th>
					    </tr>
                    </thead>
                    <tbody>
                        {
                            reportHistories.data.length > 0 ?
                                reportHistories.data.map((report, index) => (
                                    <tr key={index}>
                                        <td>
                                            {reportsQuerys.find(data => report.name === data.query).name}
                                        </td>
                                        <td>
                                            {utcDateFormat(report.created_at, "ll, h:mm:ss a")}
                                        </td>
                                        <td>
                                            {
                                                report.args && report.args.parameters && report.args.parameters.beg && report.args.parameters.end ? (
                                                    `${utcDateFormat(report.args.parameters.beg)} - ${utcDateFormat(report.args.parameters.end)}`
                                                ) : (
                                                    "No aplica"
                                                )
                                            }
                                        </td>
                                        <td>
                                            {
                                                report.status === "available" ? (
                                                    <Button
                                                        color="primary"
                                                        onClick={() => window.open(report.download_link, '_blank')}
                                                    >
                                                        Descargar
                                                    </Button>
                                                ) : (
                                                    <span className={`font-lg badge badge-${reportStatusStyle[report.status]}`}>
                                                        {report.status !== "generating" ? (
                                                            json_lang.reports[report.status]
                                                        ) : (
                                                            report.progress.toFixed(2) +  "%"
                                                            )
                                                        }
                                                    </span>
                                                )
                                            }
                                        </td>
                                    </tr>
                            ))
                            : (
                                <tr>
                                    <td colSpan={4} className="text-center" style={{ paddingBottom: "6rem", paddingTop: "6rem" }}>
                                        <big className="text-muted">
                                            {json_lang.common.no_results_msg}
                                        </big>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>
        }
        
		return <div className="d-flex flex-column justify-content-center align-items-center" style={{ margin: "20%" }}>
			<h3 className="text-muted">
                Ocurrió un error al cargar los datos
            </h3>
            <Button
                color="primary"
                onClick={() => this.handleReload()}
            >
                Recargar
            </Button>
		</div>
	}
}


const mapStateToProps = (state) => ({
	session: state.session,
	json_lang: state.json_lang,
    reportHistories: state.reportHistories,
    companyColor: state.company.styles_json.styles.color_primary
})

const mapDispatchToProps = (dispatch) => ({
	apiReportHistories:(accountId) => dispatch(apiReportHistories(accountId)),
})


export default connect(mapStateToProps,mapDispatchToProps)(ModalReportsHistories);



// WEBPACK FOOTER //
// ./src/views/Reports/ModalReportsHistories.jsx